"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
function CheckboxGroup(_a) {
    var name = _a.name, options = _a.options;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "appform-field-group" }, { children: options.map(function (a) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "appform-field__checkbox" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", name: name, id: a.id, value: a.id }), (0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: a.id, className: "appform-field__label" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "appform-field__label-name" }, { children: a.name })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "appform-field__label-price" }, { children: a.price }))] }))] }), a.id)); }) })));
}
exports.default = CheckboxGroup;
